import { Pie } from '@ant-design/plots';
import React from 'react';

const DashBoard = () => {
  const data = [
    {
      type: 'savings',
      value: 27,
    },
    {
      type: 'loans',
      value: 25,
    },
    {
      type: 'dormunt accounts',
      value: 18,
    },
    {
        type: 'fixed deposits',
        value: 100,
      },
  ];
  const config = {
    appendPadding: 10,
    data,
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    label: {
      type: 'outer',
      content: '{name} {percentage}',
    },
    interactions: [
      {
        type: 'pie-legend-active',
      },
      {
        type: 'element-active',
      },
    ],
  };
  return <Pie {...config} />;
};
export default DashBoard;